import throttle from 'lodash/throttle';

import configureStore from 'core/store/configureStore';
import ILocalCacheService from "../service/cache/ILocalCacheService";
import ServiceRegistry from "../util/ServiceRegistry";

/**
 * @overview: Creates the redux store, ensures we have a token and
 * dispatches initial required actions.
 *
 * This is the startup sequence of the application
 *
 * @author: jesposito
 */

const store = configureStore();
const cacheService = ServiceRegistry.get(ILocalCacheService);

// add subscriber for saving the state to local storage
store.subscribe(throttle(() => (
	cacheService.put("store", store.getState())
), 1000));

export default store;



// WEBPACK FOOTER //
// ./src/core/store/initStore.ts